import { useState } from "react"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useAppSelector } from "hooks/storeHooks"
import { selectBillingEntitlement } from "store/billing/billingSlice"
import { selectUserInfo } from "store/user/userSlice"
import { billingApi } from "services/billingApi"
import { useAlert } from "providers/AlertProvider"
import { IntegrationType } from "types"

export const useBillingPortal = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const userInfo = useAppSelector(selectUserInfo)
  const billingEntitlement = useAppSelector(selectBillingEntitlement)
  const { showAlert } = useAlert()
  const [isPortalLoading, setIsPortalLoading] = useState(false)

  const canManageBilling =
    userInfo.integrationType === IntegrationType.COMMON &&
    !userInfo.groups.some((group) => group.trim().toLowerCase() === "admin") &&
    billingEntitlement !== null &&
    billingEntitlement.lockReason !== "trial_canceled" &&
    billingEntitlement.entitlementStatus !== "manual_contract"

  const openBillingPortal = async () => {
    try {
      setIsPortalLoading(true)
      const session = await billingApi.stripePortalSession({
        returnPath: `${location.pathname}${location.search}`,
      })
      if (!session.url) {
        showAlert({
          error: true,
          text: t(
            "userSettingsPage.manageBillingError",
            "We couldn't open your plan page. Please try again."
          ),
        })
        return
      }
      window.location.assign(session.url)
    } catch {
      showAlert({
        error: true,
        text: t(
          "userSettingsPage.manageBillingError",
          "We couldn't open your plan page. Please try again."
        ),
      })
    } finally {
      setIsPortalLoading(false)
    }
  }

  return { canManageBilling, isPortalLoading, openBillingPortal }
}
